<!-- 老师管理 -->
<template>
	<div class="fuzzy-matching-box">
		<div class="tongji">
			<el-row :gutter="70">
				<el-col :span="8">
					<el-text class="max-size">{{facetotal}}</el-text>
					<el-text class="min-size">总人数</el-text>
				</el-col>

				<el-col :span="8">
					<el-text class="max-size">{{faceCount}}</el-text>
					<el-text class="min-size">已录入人脸数</el-text>
				</el-col>

				<el-col :span="8">
					<el-text class="max-size">{{faceCount}}</el-text>
					<el-text class="min-size">人脸总数</el-text>
				</el-col>
			</el-row>
		</div>

		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="用户名:">
						<el-input v-model="Dform.userName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="姓名:">
						<el-input v-model="Dform.name" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="学校:">
						<el-input v-model="Dform.schoolName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
				</el-col>
				<el-button type="primary" class="right query-button" @click="queryClick">查询</el-button>
				<el-button type="primary" size="medium" class="query-button" @click="batchImport">批量导入</el-button>
			</el-row>
		</div>

		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{background:'#EDF6FF',color:'#000',}" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column label="类型" show-overflow-tooltip>
						<template #default="scope">
							<span v-if="scope.row.type == 0">{{'系统管理员'}}</span>
							<span v-if="scope.row.type == 1">{{'校长'}}</span>
							<span v-if="scope.row.type == 2">{{'年级主任'}}</span>
							<span v-if="scope.row.type == 3">{{'班主任'}}</span>
							<span v-if="scope.row.type == 4">{{'教职工'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="username" label="用户名">
					</el-table-column>
					<el-table-column prop="name" label='姓名'>
					</el-table-column>
					<el-table-column prop="mobile" label="手机">
					</el-table-column>
					<el-table-column prop="schoolName" label="学校">
					</el-table-column>
					<el-table-column prop="gradeName" label="年级">
					</el-table-column>
					<el-table-column prop="className" label="班级">
					</el-table-column>
					<el-table-column label="人脸图片">
						<template #default="scope">
							<img v-if="scope.row.facePic != null" :src="scope.row.facePic + `?${getTime()}`"
								@click="UpdataFaceClick(scope.row)" style="height: 40px; width: 30px;">
							<img src="../img/add-face.png" @click="selectFile(scope.row)"
								style="height: 30px; width: 30px" v-else>
							<input type="file" style="display: none" ref="fileInput" accept=".png, .jpg, .jpeg"
								@change="handleFileChange">
						</template>
					</el-table-column>
				</el-table>
				<div class="block-fenye">
					<el-pagination :small="small" :disabled="disabled" :background="background"
						layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</div>
			</el-row>
		</div>
		<UpdateTeacherFaceView v-if="UpdataFace" @addClick="addClick" :titleValue="titleValue" :detailsObj="detailsObj">
		</UpdateTeacherFaceView>
		<ManyTeacherUpdateFace v-if="ShowManyFace" @addClick="addManyClick" :titleValue="titleValue">
		</ManyTeacherUpdateFace>
	</div>
</template>

<script>
	import {
		schoolOrUserManagementTeacherList,
		deleteTeacherInfo
	} from '@/assets/api/schoollog';
	import {
		findSchoolInfo,
		findTeacherInfo,
		findClassInfo,
		getFaceTeacherCount,
		uploadFace
	} from '@/assets/api/renyuan';
	import {
		ElMessage
	} from 'element-plus'
	import UpdateTeacherFaceView from './group/updateTeacherFaceView.vue'
	import ManyTeacherUpdateFace from './group/manyTeacherUpdateFace.vue'

	export default {
		components: {
			UpdateTeacherFaceView,
			ManyTeacherUpdateFace
		},
		data() {
			return {
				teacherObj: {},
				loading: true,
				tableData: [],
				faceCount: 0,
				facetotal: 0,
				Dform: {
					userName: "",
					name: "",
					schoolName: "",
				},
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				titleValue: '',
				AddShow: false,
				total: '',
				detailsObj: {},
				itemData: {},
				UpdataFace: false,
				ShowManyFace: false,
			};
		},
		created() {
			this.Lookteacher()
			this.schoolOrUserManagementTeacherListSearch()
		},
		mounted() {

		},
		methods: {
			selectFile(item) {
				this.$refs.fileInput.click();
				this.itemData = item;
			},

			handleFileChange(event) {
				const file = event.target.files[0];
				const reader = new FileReader();
				reader.onload = (e) => {
					const dataURL = e.target.result;
					const targetSizeKB = 300; //图片大小限制
					this.compressH5(dataURL, targetSizeKB).then(file => {
						console.log('file 222 = ', file)
						const filePath = new File([file], Date.now() + ".jpeg", {type: file.type, lastModified: Date.now()});
						if (filePath) {
							let formData = new FormData();
							formData.append("file", filePath);
							formData.append("personId ", this.itemData.id);
							formData.append("personType", "3");
							formData.append("suffix", "jpeg");
							uploadFace(formData).then((res) => {
								console.log(res);
								this.schoolOrUserManagementTeacherListSearch()
								this.$message({
									message: '人脸上传成功！',
									type: 'success'
								});
							}).catch((err) => {
								ElMessage.error("上传失败")
							})
						}
						event.target.value = '';
					}).catch(err => {
						ElMessage.error("图片压缩异常")
					})
				};
				reader.readAsDataURL(file);
			},
			
			compressH5(base64Str, targetSizeKB) {
				const maxQuality = 1.0;
				const minQuality = 0.0;
				const tolerance = 0.01; // 根据需要调整公差
				return new Promise((resolve, reject) => {
					const binarySearch = (min, max) => {
						const midQuality = (min + max) / 2;
						const img = new Image();
						img.src = base64Str;
						img.onload = function() {
							const canvas = document.createElement('canvas');
							const ctx = canvas.getContext('2d');
							
							let width = img.width;
							let height = img.height;
							while(width < 480 || width > 720){
								width = width / 4 * 3
								height = height / 4 * 3
							};
							
							canvas.width = Math.floor(width);
							canvas.height = Math.floor(height);
			
							ctx.clearRect(0, 0, canvas.width, canvas.height);
							ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
			
							// 使用异步的 toBlob 方法
							canvas.toBlob(async (blob) => {
								const fileSizeKB = blob.size / 1024;
								if (Math.abs(fileSizeKB - targetSizeKB) < tolerance || max -
									min < tolerance) {
									// 当前质量足够接近目标大小，使用当前质量解析
									resolve(blob);
								} else if (fileSizeKB > targetSizeKB) {
									// 如果文件大小太大，降低质量，继续二分查找
									binarySearch(min, midQuality);
								} else {
									// 如果文件大小太小，增加质量，继续二分查找
									binarySearch(midQuality, max);
								}
							}, 'image/jpeg', midQuality);
						};
					};
			
					// 开始二分查找
					binarySearch(minQuality, maxQuality);
				});
			},

			UpdataFaceClick(item) {
				this.detailsObj = item
				this.UpdataFace = true
			},

			Lookteacher() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				findTeacherInfo(params).then((res) => {
					console.log(res, '查看权限');
					this.teacherObj = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},


			addClick() {
				this.UpdataFace = false
				this.schoolOrUserManagementTeacherListSearch()
				this.itemData = {};
			},

			addManyClick() {
				this.ShowManyFace = false
				this.schoolOrUserManagementTeacherListSearch()
			},

			schoolOrUserManagementTeacherListSearch() {
				const params = {
					schoolName: this.Dform.schoolName,
					userName: this.Dform.userName,
					name: this.Dform.name,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				schoolOrUserManagementTeacherList(params).then((res) => {
					console.log(res, '教师管理成功');
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false
				}).catch((err) => {
					console.log(err, '教师管理失败');

				})

				getFaceTeacherCount(params).then((res) => {
					this.faceCount = res.data.data.faceCount;
					this.facetotal = res.data.data.total
				}).catch((err) => {
					console.log(err, '获取人脸数量失败');
				})
			},

			queryClick() {
				this.schoolOrUserManagementTeacherListSearch()
			},

			batchImport() {
				this.titleValue = '批量导入'
				this.ShowManyFace = true
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.schoolOrUserManagementTeacherListSearch()
			},
			
			getTime(){
				return new Date().getTime();
			}
		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 20px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.tongji {
			width: 59%;
			margin-left: 60px;

			.el-col {
				text-align: center;
			}

			.el-text {
				display: block;
				background-color: #55aaff;
				color: white;
			}

			.max-size {
				font-weight: bold;
				padding-top: 10px;
				padding-bottom: 10px;
				font-size: 25px;

			}

			.min-size {
				padding-bottom: 10px;
				font-size: 15px;
				color: #666666;
			}
		}

		.query-button {
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;
		}

		.title-top {
			padding: 20px 20px;
		}

		.fuzzy-matching-top {
			height: 70px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				:deep() {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}
				}
			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 300px;
					padding: 16px 24px;
				}

				.right {
					right: 450px;
				}

			}

			:deep() {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}
			}

		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 10px;

			:deep() {
				.el-button {
					margin-left: 50px;
					font-size: 16px;

				}
			}
		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
			}

			.shanchuBtn {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 40px;
					line-height: 40px;
					border: 0;
					font-size: 16px;
					color: black;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					border: 0;
				}

				.el-button--small {
					padding-left: 19px;
				}
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

	}
</style>